export default {
  status: {
    pending: 'A aguardar o DNS',
    verified: 'Ativo',
    failed: 'Ação necessária',
  },
  summary: {
    preparing:
      'Os registos para {{host}} estão a ser preparados. Aparecem aqui dentro de cerca de 15 minutos — ou de imediato depois de premir Verificar novamente.',
    pending:
      'A aguardar os registos DNS abaixo. Normalmente demora alguns minutos e pode levar até 48 horas — continuamos a verificar automaticamente.',
    certificate_pending:
      'Os registos estão no sítio. O certificado para {{host}} está a ser emitido — normalmente demora alguns minutos.',
    verified: 'A loja online está ativa em {{host}}.',
    serving: 'A loja online está ativa em {{serving_host}}, mas o próprio {{host}} ainda não a abre.',
    apex_elsewhere:
      'O registo A em @ ainda não aponta para a loja. Se {{host}} mostra um website que deve ficar aí, deixe @ como está — a loja funciona em {{serving_host}}. Caso contrário, adicione o registo A abaixo.',
    apex_held:
      '{{host}} é usado por outro website na Vercel. Para que {{host}} também abra a loja, remova primeiro o domínio desse website.',
    regressed:
      '{{host}} funcionava, mas um registo abaixo deixou de ser confirmado. Corrija-o no fornecedor de DNS e prima Verificar novamente.',
    record_elsewhere:
      'Um registo abaixo aponta para outro sítio. Altere-o no fornecedor de DNS para o valor indicado e prima Verificar novamente.',
    records_missing:
      'Os registos abaixo continuam sem ser encontrados após 48 horas. Verifique se foram guardados para {{zone}}, no fornecedor que gere o seu DNS. Se esse fornecedor não permitir a alteração, o domínio pode estar bloqueado aí.',
    certificate: {
      ownership_proof_required:
        '{{host}} também está ligado a outra conta Vercel, por isso o restaurante tem de provar que o domínio lhe pertence.',
      held_by_another_project:
        '{{host}} ainda é usado por outro website na Vercel, por isso a loja ainda não o pode usar.',
      dns_correct_but_unconfigured: 'Os registos estão corretos, mas outra coisa em {{host}} bloqueia o certificado.',
      name_mismatch: '{{host}} ainda responde com um certificado para outro nome.',
      expired: 'O certificado para {{host}} expirou. Fomos alertados e estamos a tratar do assunto.',
      expiring: 'O certificado para {{host}} expira em breve e ainda não foi renovado. Estamos a tratar do assunto.',
      attach_refused:
        'O nosso fornecedor de alojamento recusou adicionar {{host}} do nosso lado. Fomos alertados e estamos a tratar do assunto.',
      overdue: 'O certificado para {{host}} ainda não foi emitido após 48 horas.',
      unknown: 'Não foi possível emitir o certificado para {{host}}.',
    },
    certificate_see_row: 'A linha do certificado abaixo indica o que fazer.',
  },
  instructions: {
    title: 'Como ligar {{host}}',
    step_provider: 'Inicie sessão onde o DNS de {{zone}} é gerido — normalmente a empresa onde o domínio foi comprado.',
    step_add: 'Adicione cada registo abaixo exatamente como indicado: o tipo, o nome e o valor.',
    step_check: 'Guarde e prima {{button}}. Também continuamos a verificar automaticamente.',
    tip_name:
      'A maioria dos fornecedores quer apenas a parte antes de {{zone}} no campo do nome — aqui {{names}}. O nome completo também é mostrado, para os fornecedores que o pedem.',
    tip_apex: '@ representa o próprio {{zone}}. Alguns fornecedores deixam o nome vazio em alternativa.',
    tip_apex_website:
      'Se {{zone}} já abre um website, apontar @ para a loja retira {{zone}} a esse website. Para manter o website aí, deixe os registos em @ como estão — a loja continua a funcionar em www.{{zone}} — ou ligue antes um subdomínio como order.{{zone}} para a loja.',
    tip_existing:
      'Remova qualquer outro registo A, AAAA ou CNAME em {{name}}. Dois registos que apontam para sítios diferentes fazem a loja carregar só algumas vezes.',
    tip_cloudflare:
      'No Cloudflare, defina estes registos como Apenas DNS (nuvem cinzenta). Com o proxy ativo, ninguém consegue ver para onde apontam e não é possível emitir nenhum certificado.',
    tip_locked:
      'Se o fornecedor não permitir adicionar ou alterar estes registos, o domínio pode estar bloqueado ou o seu DNS pode ser gerido noutro sítio. O fornecedor pode desbloqueá-lo ou indicar onde o DNS é gerido.',
  },
  records: {
    title: 'Registos para {{host}}',
  },
  separate_domains: {
    apex: 'Este domínio é apenas para a loja online: a loja ocupa {{zone}} e www.{{zone}}. Um website precisa de outro nome — um subdomínio de {{zone}} ou um domínio próprio.',
    subdomain: 'Este domínio é apenas para a loja online. Um website pode usar {{zone}} ou www.{{zone}}.',
  },
  load_error: 'Não foi possível carregar o estado do domínio.',
  no_access: 'Sem acesso ao estado do domínio deste restaurante.',
  polling_stopped: 'Esta página deixou de se atualizar sozinha. Prima Verificar novamente para a atualizar.',
  buttons: {
    check_again: 'Verificar novamente',
    retry: 'Tentar novamente',
  },
  toasts: {
    check_started: 'A verificar os registos. Pode demorar um minuto.',
    check_failed: 'Não foi possível iniciar a verificação. Tente novamente.',
    check_too_soon: 'Acabou de ser verificado. Aguarde um minuto antes de verificar novamente.',
  },
};
